import { Card, CardContent, CardHeader, Stack } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { FormTextFieldName } from "../../../../../components/common/form-text-field-name";
import { FormTextFieldNotes } from "../../../../../components/common/form-text-field-notes";

export const CatalogsCreateCreateCatalogCard = () => {
  const { t } = useTranslation(["catalogs"]);

  return (
    <Card elevation={0}>
      <CardHeader
        subheader={t("catalogs:catalogs.create.catalog.card.sub.title")}
        title={t("catalogs:catalogs.create.catalog.card.title")}
      />
      <CardContent>
        <Stack direction="column" spacing={2}>
          <FormTextFieldName label={t("catalogs:catalogs.form.fields.catalog.name.label")} />

          <FormTextFieldNotes optional />
        </Stack>
      </CardContent>
    </Card>
  );
};
